module.exports = __webpack_public_path__ + "img/unimed-robozinho.d20c999a.svg";